import React, { useState } from "react";
import axios from "axios";
import { baseurl } from "../../../Baseurl";
import AdminSidebar from "../../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../../component/AdminComp/AdminTopbar";
import Swal from "sweetalert2";
import ServiceCategoryNavbar from "./ServiceCategoryNavbar";

const ServiceCategory = () => {
  const [title, setTitle] = useState("");

  const generateSlug = (text) => {
    return text.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9\-]/g, "");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        service_title: title,
        is_parent: true,
        has_service: false,
        slug: generateSlug(title)
      };

      await axios.post(`${baseurl}addServiceCategory`, payload);
      Swal.fire("Success", "What We Do category added!", "success").then(() => window.location.reload());
    } catch (err) {
      console.error("Submit error:", err);
      Swal.fire("Error", "Failed to add category", "error");
    }
  };

  return (
   <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid text-start">

          <ServiceCategoryNavbar/>
          <div className="crd1">
            <h4 className="mb-3">Add "What We Do" For Service/Repair</h4>
            <div className="row">
<div className="col-md-6">
  <form onSubmit={handleSubmit} className="row g-3 text-start">

              <div className="col-md-12">
                <label>Title</label>
                <input
                  type="text"
                  className="form-control"
                  required
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </div>

              <div className="col-12 text-end">
                <button type="submit" className="btn btn-primary">Add</button>
              </div>

            </form>
</div>
 
            </div>
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceCategory;
